import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { purposes } from '../../data/purposes';
import { getOptimizedImageUrl } from '../../utils/image';

export const ShopByPurpose = () => {
  return (
    <section className="py-12 lg:py-16 bg-white" data-testid="purpose-section">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-serif text-2xl lg:text-3xl font-bold text-foreground mb-2">
            Shop by <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-orange-600">Purpose</span>
          </h2>
          <p className="text-muted-foreground text-sm">
            Find the perfect spiritual item for your specific needs
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {purposes.map((purpose, index) => (
            <motion.div
              key={purpose.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
            >
              <Link
                to={`/products?purpose=${purpose.id}`}
                className="group block relative overflow-hidden rounded-xl aspect-[3/4] shadow-md hover:shadow-xl transition-all duration-300"
                data-testid={`purpose-${purpose.id}`}
              >
                {/* Background Image */}
                <div className="absolute inset-0">
                  <img
                    src={getOptimizedImageUrl(purpose.image, 400)}
                    alt={purpose.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${purpose.color}`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                </div>

                {/* Content */}
                <div className="relative h-full flex flex-col justify-end p-3 lg:p-4">
                  <h3 className="font-semibold text-white text-sm lg:text-base mb-0.5 group-hover:text-amber-300 transition-colors leading-tight">
                    {purpose.name}
                  </h3>
                  <p className="text-white/70 text-xs hidden sm:block">
                    {purpose.description}
                  </p>
                  
                  {/* Arrow indicator */}
                  <div className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white/20 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:bg-white/30">
                    <ArrowRight className="w-4 h-4 text-white" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
